(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-list-manual"] && !Shopify.designMode) return;
  try {
    
if ('IntersectionObserver' in window) {
  var t4sInitScrollHover = function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        entry.target.classList.toggle('t4s-scroll-active', entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-40% 0px -40% 0px' });

    document.querySelectorAll('.t4s_cat_item_link').forEach(function(link) {
      observer.observe(link);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', t4sInitScrollHover);
  } else {
    t4sInitScrollHover();
  }
}

  } catch(e) { console.error(e); }
})();
})();
